// Session ENR: one quiet line on the site and project pages when an ELE number is reserved there. Read only and no new page:
// a reservation is made and released from chat, and this says what the office needs to know when looking at the record. Read
// fresh every time, because a reservation made from chat never clears this browser's request cache. A failed read shows nothing:
// the number's own holder is the reserve tool's refusal, and this line is a courtesy beside it.
import { useEffect, useState } from "react";
import { api } from "../lib/api";
import type { EleReservationView } from "../lib/api";

function sentence(r: EleReservationView): string {
  const lifts = r.lifts.map((l) => `${l.eleNumber} (${l.for})`).join(", ");
  const given = r.issuedExternally ? ` Given to ${r.issuedExternally.to}${r.issuedExternally.on ? ` on ${r.issuedExternally.on}` : ""}.` : "";
  if (r.status === "assigned") {
    return r.unusedLiftNumbers.length > 0 ? `${r.unusedLiftNumbers.join(", ")} still held for this site from reservation ${r.reference}.${given}` : "";
  }
  return `ELE number ${r.reference} reserved: ${lifts}.${given} Not a contract: a signing at this site takes these numbers.`;
}

export function EleReservationLine({ siteId, projectId }: { siteId?: string; projectId?: string }) {
  const [lines, setLines] = useState<{ reference: string; text: string }[]>([]);
  useEffect(() => {
    let live = true;
    api.eleReservations.list({ siteId, projectId }).then(
      (res) => {
        if (!live) return;
        setLines(res.reservations.map((r) => ({ reference: r.reference, text: r.status === "released" ? "" : sentence(r) })).filter((l) => l.text));
      },
      () => undefined,
    );
    return () => {
      live = false;
    };
  }, [siteId, projectId]);
  if (lines.length === 0) return null;
  return (
    <div className="mb-3 text-sm text-ele-body" data-testid="ele-reservation-line">
      {lines.map((l) => (
        <p key={l.reference}>{l.text}</p>
      ))}
    </div>
  );
}
